import React from 'react';
import RulesLottie from '../RulesLottie';

export default function RulesHero() {
  return (
    <div className="bg-primary text-white py-8">
      <div className="container mx-auto px-4 text-center">
        <RulesLottie className="mb-2" />
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Reglas del Concurso</h1>
        <p className="text-xl text-gray-200 max-w-2xl mx-auto">
          Participa en nuestro emocionante concurso y muestra tu creatividad navideña
        </p>
      </div>
    </div>
  );
}